import { UserOutlined } from "@ant-design/icons";
import { Avatar, Button, Divider, Dropdown, Typography } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { logOut } from "store/user/auth/user_auth.action";
import {
  displayNameSelector,
  emailSelector,
  photoURLSelector,
} from "store/user/auth/user_auth.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const NavbarAvatar = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const photoURL = useSelector(photoURLSelector);
  const email = useSelector(emailSelector);
  const displayName = useSelector(displayNameSelector);
  const name = String(email)?.split("@")?.[0];
  // -------------------------- FUNCTION ------------------------
  const handleLogout = () => {
    dispatch(logOut());
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderDropdown = () => {
    return (
      <div className="mt-[10px] min-h-[100px] min-w-[200px] rounded-md border-[1px] !border-gray-300 bg-white p-5 shadow-md">
        <div className="flex flex-row gap-2">
          <Avatar src={photoURL} size={38} icon={<UserOutlined />} />
          <div>
            <Typography.Title
              style={{ padding: 0, margin: 0 }}
              level={5}
              ellipsis={{ rows: 1 }}
            >
              {displayName || name}
            </Typography.Title>
            <div className="italic">{name}</div>
          </div>
        </div>
        <Divider />
        <Button onClick={handleLogout} block className="min-h-[50px]">
          Đăng xuất
        </Button>
      </div>
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <>
      <a
        href="/bailiff"
        className="bg-primary-700 hover:bg-primary-500 rounded-xl border border-white/10 px-6 py-2.5 text-sm font-bold text-white shadow-lg transition-colors"
      >
        Tải file ngay
      </a>
      <div className="bg-primary-700 hover:bg-primary-500 flex w-fit flex-row items-center gap-2 rounded-full border border-white/10 p-1 text-sm font-bold text-white shadow-lg transition-colors">
        <Dropdown
          placement="bottomCenter"
          trigger={["hover"]}
          popupRender={renderDropdown}
        >
          <Avatar
            className="cursor-pointer"
            src={photoURL}
            size={38}
            icon={<UserOutlined />}
          />
        </Dropdown>
      </div>
    </>
  );
};
export default NavbarAvatar;
